
import Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
// import exportmodule from "highcharts/modules/exporting";
more(Highcharts);
// exportmodule(Highcharts);


export default (node, config) => {

    const redraw = true;
    const oneToOne = true;
    const chart = Highcharts.chart(node, config);

    return {
        update(config) {
            chart.update(config, redraw, oneToOne);
        },
        destroy() {
            chart.destroy();
        }
    };
}
